import { useState } from "react";
import { Button, Checkbox, Typography, message } from "antd";
import ExpiryCountdown from "./ExpiryCountdown";
import SocialMediaCards from "./SocialMediaCards";
import { CONSENT_CLAUSES } from "../../utils/deliveryConsent";
import { useTranslation } from "../../i18n";

const { Title, Paragraph } = Typography;

function ConsentPanel({
    expiryUtcSeconds,
    clauseIds = [],
    clauses = CONSENT_CLAUSES,
    onAgree,
    onLeave,
    onExpired,
    consentNs = "delivery.consent",
}) {
    const { t } = useTranslation();
    const [agreed, setAgreed] = useState(false);
    const [highlight, setHighlight] = useState(false);
    const selectedIds = new Set(clauseIds);
    const selectedClauses = clauses.filter((clause) => selectedIds.has(clause.id));
    const orderedClauses = [
        ...selectedClauses.filter((clause) => clause.kind !== "social"),
        ...selectedClauses.filter((clause) => clause.kind === "social"),
    ];

    let termIndex = 0;

    const handleAgree = () => {
        if (!agreed) {
            message.warning(t(`${consentNs}.checkRequired`));
            setHighlight(false);
            requestAnimationFrame(() => setHighlight(true));
            return;
        }
        onAgree?.();
    };

    const handleCheckboxChange = (e) => {
        setAgreed(e.target.checked);
        if (e.target.checked) {
            setHighlight(false);
        }
    };

    return (
        <div className="delivery-card delivery-consent">
            <ExpiryCountdown expiryUtcSeconds={expiryUtcSeconds} onExpired={onExpired} />

            <Title level={3} className="delivery-consent__title">
                {t(`${consentNs}.title`)}
            </Title>

            {orderedClauses.map((clause) => {
                if (clause.kind === "social") {
                    return <SocialMediaCards key={clause.id} consentNs={consentNs} />;
                }
                const text = t(`${consentNs}.clauses.${clause.key}`);
                if (clause.kind === "term") {
                    termIndex += 1;
                    return (
                        <Paragraph key={clause.id} className="delivery-consent__text">
                            {`${termIndex}. ${text}`}
                        </Paragraph>
                    );
                }
                return (
                    <Paragraph key={clause.id} className="delivery-consent__text">
                        {text}
                    </Paragraph>
                );
            })}

            <div className="delivery-consent__actions">
                <Checkbox
                    className={`delivery-consent__checkbox${
                        highlight ? " delivery-consent__checkbox--error" : ""
                    }`}
                    checked={agreed}
                    onChange={handleCheckboxChange}
                    onAnimationEnd={() => setHighlight(false)}
                >
                    {t(`${consentNs}.checkbox`)}
                </Checkbox>
                <Button type="primary" size="large" block onClick={handleAgree}>
                    {t(`${consentNs}.agree`)}
                </Button>
                <Button type="default" size="large" block onClick={onLeave}>
                    {t(`${consentNs}.leave`)}
                </Button>
            </div>
        </div>
    );
}

export default ConsentPanel;
